// A library reused throughout the entire application

/* ***** API - URL ***** */

const API_URL = process.env.REACT_APP_API_HOST;

export const getApiUrl = () => API_URL;

export const wait = ms => {
  return new Promise((r, j) => setTimeout(r, ms));
};

const fallbackCopyTextToClipboard = text => {
  var textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
};

export const copyTextToClipboard = text => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function () {
      console.log('Async: Copying to clipboard was successful!');
    },
    function (err) {
      console.error('Async: Could not copy text: ', err);
    },
  );
};

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ')
}

export const theme = {
  darkBlue: "#030130",
  purple: "#8072fe",
  blue: "#5187ff",
  turquoise: "#91d7f4",
  gray: "#c7c7c7",
  lightGray: "#eef0f3"
};